import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isEqual } from 'lodash';
import { HYDRATE } from 'next-redux-wrapper';
import { WritableDraft } from 'immer';
import { TripTypes } from '@model/common';

export interface RecentlyViewedItem {
  type: RecentlyViewedType;
  id: any;
  tripType: TripTypes;
}

export enum RecentlyViewedType {
  FIT = 'fit',
  TOURS = 'tours'
}

export const INITIAL_RECENTLY_VIEWED_STATE: Array<RecentlyViewedItem> = [];

export type RecentlyViewedState = Array<RecentlyViewedItem>;

const recentlyViewedSlice = createSlice({
  name: 'recentlyViewed',
  initialState: INITIAL_RECENTLY_VIEWED_STATE,
  reducers: {
    addRecentlyViewed: (state: Array<WritableDraft<RecentlyViewedItem>>, action: PayloadAction<RecentlyViewedItem>) => {
      const newItems: Array<RecentlyViewedItem> = [action.payload];
      const existingItems: Array<RecentlyViewedItem> = state;
      if (existingItems.some((item: RecentlyViewedItem) => item.id === action.payload.id)) {
        return newItems.concat(
          existingItems.filter((entry) => {
            if (entry.id !== action.payload.id) {
              return true;
            }

            if (entry.id === action.payload.id && entry.tripType !== action.payload.tripType) {
              return true;
            }

            return false;
          })
        );
      }
      if (existingItems.length < 4) {
        return newItems.concat(existingItems);
      }
      return newItems.concat(existingItems).slice(0, 4);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state: RecentlyViewedState, action: any): Array<RecentlyViewedItem> => {
      if (isEqual(state, INITIAL_RECENTLY_VIEWED_STATE)) {
        return action.payload.recentlyViewed || state;
      }
      return state;
    });
  }
});

export const { addRecentlyViewed } = recentlyViewedSlice.actions;
export const recentlyViewedReducer = recentlyViewedSlice.reducer;
